import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {
  DistributionSchedule,
  DistributionScheduleRequest,
} from '../../models/distribution-schedule.model';

/**
 * Client for recurring distribution schedules (/api/distribution-schedules).
 * The Distributions page configures schedules; the generated runs live under Reports.
 */
@Injectable({ providedIn: 'root' })
export class DistributionScheduleService {
  private baseUrl = `${environment.apiUrl}/api/distribution-schedules`;

  constructor(private http: HttpClient) {}

  list(): Observable<DistributionSchedule[]> {
    return this.http.get<DistributionSchedule[]>(this.baseUrl);
  }

  get(id: number): Observable<DistributionSchedule> {
    return this.http.get<DistributionSchedule>(`${this.baseUrl}/${id}`);
  }

  create(body: DistributionScheduleRequest): Observable<DistributionSchedule> {
    return this.http.post<DistributionSchedule>(this.baseUrl, body);
  }

  update(id: number, body: DistributionScheduleRequest): Observable<DistributionSchedule> {
    return this.http.put<DistributionSchedule>(`${this.baseUrl}/${id}`, body);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }
}
